export default __webpack_public_path__ + "static/media/nft.7da89210.png";